import axios, { AxiosResponse } from 'axios';

export const getFalseDeals = (params: any): Promise<AxiosResponse> => {
    return axios.get(`/services/isnaportal/open-api/false-deal`, { params });
};
